import React, { useMemo } from "react";
import { keys } from "lodash";
import ToolbarFilterButton from "@/components/controls/ToolbarActions/ToolbarFilterButton/ToolbarFilterButton";
import FilterChip from "@/components/controls/Filters/FilterChip";
import { hasActiveFilterValue } from "@/components/controls/ToolbarActions/utils";
import { getFilterLabel } from "@/hooks/useFilterOptions";
import { DataTableFilter } from "@/components/controls/DataTableFilters/DataTableFilters";
import { Filters, FiltersSetter } from "@/services/api/types";

interface DreamerAttachmentFilterToolbarProps {
  filters: Filters;
  setFilters: FiltersSetter;
  filterOptions: DataTableFilter[];
}

const DreamerAttachmentFilterToolbar: React.FC<DreamerAttachmentFilterToolbarProps> = ({
  filters,
  setFilters,
  filterOptions
}) => {
  const activeFilterKeys = useMemo(
    () => keys(filters).filter((key) => hasActiveFilterValue(filters[key])),
    [filters]
  );

  const removeFilter = (filterKey: string) => {
    setFilters((prev) => {
      const next = { ...prev };
      delete next[filterKey];
      return next;
    });
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <ToolbarFilterButton
        allFilterOptions={filterOptions}
        filters={filters}
        setFilters={setFilters}
        hasActiveFilters={activeFilterKeys.length > 0}
      />
      {activeFilterKeys.map((filterKey) => {
        const filterOption = filterOptions.find((opt) => opt.key === filterKey);
        if (!filterOption) return null;
        const isMonetary =
          filterOption.filterType.type === "numeric" &&
          filterOption.filterType.isMonetary === true;
        const isPercentage =
          filterOption.filterType.type === "numeric" &&
          filterOption.filterType.isPercentage === true;
        return (
          <FilterChip
            key={filterKey}
            filterKey={filterKey}
            filterLabel={getFilterLabel(filterOption)}
            filterOption={filterOption}
            filters={filters}
            setFilters={setFilters}
            onRemove={() => removeFilter(filterKey)}
            isMonetary={isMonetary}
            isPercentage={isPercentage}
          />
        );
      })}
    </div>
  );
};

export default DreamerAttachmentFilterToolbar;
